import BoletinCreateView from './views/BoletinCreateView.vue'
import BoletinListView from './views/BoletinListView.vue'
import BoletinView from './views/BoletinView.vue'

export default [
  {
    path: '/comunicacion-nuevo',
    name: 'nuevoBoletin',
    component: BoletinCreateView
  },
  {
    path: '/comunicaciones',
    name: 'boletines',
    component: BoletinListView
  },
  {
    path: '/comunicacion/:id',
    name: 'detalleBoletin',
    component: BoletinView
  }
]
